import {AfterViewInit, ChangeDetectionStrategy, Component, computed, DestroyRef, Inject, Injectable, Signal, signal, viewChild} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {AksjeeierbokId, AksjeeierEnkelModell, EnkelGruppeModell, GruppeId, GruppeModell, GruppeRessursClient, Gruppetype, MalmøteModell, MalmøteRessursClient, MedlemsRolleModell, MøtedeltakerSpesifikasjon, MøteModell, MøteRessursClient, NyttMøteSpesifikasjon, OpprettMøteValideringsfeil, TilgangsrolleMedlem} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatIconModule} from "@angular/material/icon";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";
import {MøteRedigerDetaljerKontroller} from "../../komponenter/møte-rediger-detaljer/møte-rediger-detaljer";
import {MatInputModule} from "@angular/material/input";
import {MatFormFieldModule} from "@angular/material/form-field";
import {takeUntilDestroyed, toObservable, toSignal} from "@angular/core/rxjs-interop";
import {filterNil} from "@ngneat/elf";
import {BehaviorSubject, combineLatest, debounceTime, filter, Observable, switchMap, tap} from "rxjs";
import {nyUuid} from "felles-ng2/støttefunksjoner/uuidGenerator";
import {MøteRedigerTidspunktKontroller, MøteRedigerTidspunktKontrollerAvhengigheter, MøteRedigerTidspunktKontrollerAvhengigheter_DI_TOKEN, MøtetidspunktValideringsfeil} from "../../komponenter/møte-rediger-tidspunkt/møte-rediger-tidspunkt";
import {første} from "felles-ng2/støttefunksjoner/lister";
import {MøteOpprettInkluderteSakerKontroller} from "../../komponenter/møte-opprett-inkluderte-saker/møte-opprett-inkluderte-saker";
import {DeltakereSkjemaVerdier, MøteRedigerDeltakereKontroller} from "../../komponenter/møte-rediger-deltakere/møte-rediger-deltakere";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {MøteRedigerEksterneDeltakereKontroller} from "../../komponenter/møte-rediger-eksterne-deltakere/møte-rediger-eksterne-deltakere";
import {MatStepper, MatStepperModule} from "@angular/material/stepper";
import {Temporal} from "temporal-polyfill";
import {MøteOpprettPubliseringKontroller} from "web-ng2/moduler/møte/komponenter/møte-opprett-publisering/møte-opprett-publisering";
import {TypetValideringsresultatModell} from "felles-ng2/tjenester/ressurser/ng2HttpKlientTilleggstyper";
import {GeneralforsamlingRedigerRepresentasjonerKontroller, GfRedigerRepresentasjonerSkjemaVerdier} from "web-ng2/moduler/møte/komponenter/generalforsamling-rediger-representasjon/generalforsamling-rediger-representasjoner";
import {AksjeeierDatatjeneste} from "felles-ng2/tjenester/datalager/AksjeeierDatatjeneste";
import {finnAksjeeierRolle, grupperDerBrukerHarTilgangsrolle} from "felles-ng2/modell/gruppeModellHjelpere";
import {Navigasjon} from "web-ng2/tjenester/Navigasjon";
import {RedigerMøtemalDialogTjeneste, RedigerMøtemalTrinn} from "web/moduler/gruppe/modale/redigerMøtemalDialog/redigerMøtemalDialog";
import {kopierFraAjsTilNg2, kopierFraNg2TilAjs} from "felles-ng2/modell/ajsNg2ModellBroer";
import {GjeldendeTidssone, Tidssoneinformasjon} from "felles-ng2/tjenester/i18n/GjeldendeTidssone";
import {BrukerkontekstTilbyder} from "felles-ng2/tjenester/BrukerkontekstTilbyder";
import {TranslateModule} from "@ngx-translate/core";
import {i18n} from "felles-ng2/tjenester/i18n/Oversettelser";
import {VelgGruppeKomponent} from "web-ng2/moduler/gruppe/komponenter/velg-gruppe/velg-gruppe";
import {MedlemInvitasjonSkjemaKomponentAvhengigheter, MedlemInvitasjonSkjemaKomponentAvhengigheter_DI_TOKEN} from "web-ng2/moduler/medlem/komponenter/medlem-invitasjon-skjema/medlem-invitasjon-skjema";
import {okTypetValideringsresultatModell} from "felles-ng2/støttefunksjoner/valideringsresultatModellHjelpere";
import {eksistererMedlemMedEpost, eksistererMedlemMedNavn, medlemmerAktive, medlemmerIkkeAnonymisert, ValiderEpostRespons} from "felles-ng2/modell/medlemModellHjelpere";
import {lesPlainTimeSerialisertOpt} from "felles-ng2/støttefunksjoner/temporal";
import {GruppeDatatjeneste} from "felles-ng2/tjenester/datalager/GruppeDatatjeneste";
import {map} from "rxjs/operators";
import {promiseMedResolvere} from "felles-ng2/støttefunksjoner/promiser";
import {DataOgMeta, kunRequestRespons, mapTilData} from "felles-ng2/tjenester/datalager/DataOgMeta";
import {MøteRedigerDeltakereGeneralforsamlingKontroller} from "web-ng2/moduler/møte/komponenter/møte-rediger-deltakere-gf/møte-rediger-deltakere-gf";
import {asynkArbeidPågårSignal} from "felles-ng2/tjenester/AsynkArbeidPågårSignal";
import {MøteDatatjeneste} from "felles-ng2/tjenester/datalager/MøteDatatjeneste";
import {VisDersomIkkeScrolletTilBunnDirektiv} from "web-ng2/delt/direktiver/visDersomIkkeScrolletTilBunn/visDersomIkkeScrolletTilBunn";
import {ZonedDateTimePeriodeLukket} from "felles-ng2/typer/ZonedDateTimePeriode";
import PlainDate = Temporal.PlainDate;

const debug = initDebugger('MøteOpprettDialogKomponent');

export type MøteOpprettDialogRespons = { opprettetMøte: MøteModell, sendInnkalling: boolean } | null;
export type SkjemaType = MøteOpprettDialogKomponent['skjema']
export type SkjemaVerdier = SkjemaType['value'];

@Component({
    selector: 'moete-opprett-dialog',
    templateUrl: 'møte-opprett-dialog.html',
    styleUrls: ['møte-opprett-dialog.scss'],
    providers: [
        {provide: MøteRedigerTidspunktKontrollerAvhengigheter_DI_TOKEN, useExisting: MøteOpprettDialogKomponent},
        {provide: MedlemInvitasjonSkjemaKomponentAvhengigheter_DI_TOKEN, useExisting: MøteOpprettDialogKomponent}
    ],
    imports: [
        FormsModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        MatToolbarModule,
        MøteRedigerDetaljerKontroller,
        VisSpinnerDirektiv,
        ReactiveFormsModule,
        MatInputModule,
        MatFormFieldModule,
        MøteOpprettInkluderteSakerKontroller,
        MøteRedigerDeltakereKontroller,
        MøteRedigerEksterneDeltakereKontroller,
        MatStepperModule,
        MøteOpprettPubliseringKontroller,
        GeneralforsamlingRedigerRepresentasjonerKontroller,
        TranslateModule,
        VelgGruppeKomponent,
        MøteRedigerDeltakereGeneralforsamlingKontroller,
        VisDersomIkkeScrolletTilBunnDirektiv,

    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MøteOpprettDialogKomponent implements MøteRedigerTidspunktKontrollerAvhengigheter, MedlemInvitasjonSkjemaKomponentAvhengigheter, AfterViewInit {

    static vis(dialog: MatDialog, valgtGruppeId: GruppeId | null = null, valgtStartdato: PlainDate | null = null): MatDialogRef<MøteOpprettDialogKomponent, MøteOpprettDialogRespons> {
        return dialog.open(MøteOpprettDialogKomponent, {data: {valgtGruppeId, valgtStartdato} as DialogParametre, disableClose: true, ariaLabelledBy: 'møte-opprett-dialog-tittel'/*, minHeight: 670*/});
    }

    private steg = viewChild.required<MatStepper>('steg');
    private velgGrupperKomponent = viewChild.required(VelgGruppeKomponent);

    skjema = new FormGroup({
        gruppe: new FormControl<GruppeModell | null>(null, {nonNullable: true, validators: [Validators.required]}),
        detaljer: MøteRedigerDetaljerKontroller.opprettSkjema(),
        saker: MøteOpprettInkluderteSakerKontroller.opprettSkjema(),
        deltakere: MøteRedigerDeltakereKontroller.opprettSkjema(),
        eksterneDeltakere: MøteRedigerEksterneDeltakereKontroller.opprettSkjema(),
        aksjeeiere: GeneralforsamlingRedigerRepresentasjonerKontroller.opprettSkjema(), //aksjeeiere er kun relevant dersom gruppen har aksjeeierbok
        publisering: MøteOpprettPubliseringKontroller.opprettSkjema()
    });

    grupper = signal<GruppeModell[]>([]);
    valgtGruppe: Signal<GruppeModell | null>;
    malmoete = signal<MalmøteModell | null>(null);
    erGeneralforsamling = computed(() => this.valgtGruppe()?.harAksjeeierbok ?? false);
    standardAksjeeierRolle = signal<MedlemsRolleModell | null>(null);

    lagrer = asynkArbeidPågårSignal();
    fokuserStartdatoFelt = signal(false);

    /** Oppdateres via {@link #lastAksjeeiereOgOppdaterSkjema} */
    private medlemsroller$ = new BehaviorSubject<MedlemsRolleModell[]>([]);
    private ngViewInitialisert = promiseMedResolvere<void>();

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                private avhengigheter: MøteOpprettDialogKomponentAvhengigheter,
                public dialogRef: MatDialogRef<MøteOpprettDialogKomponent, MøteOpprettDialogRespons>,
                private destroyRef: DestroyRef) {
        this.valgtGruppe = toSignal(this.skjema.controls.gruppe.valueChanges, {initialValue: null});

        this.skjema.controls.detaljer.controls.tidspunkt.controls.startdato.setValue(parametre.valgtStartdato);
        this.lastGrupper(parametre.valgtGruppeId);
        this.oppdaterSkjemaNårGruppevalgEndres();
    }

    gaaTilRepresentasjonSteg() {
        this.steg().selectedIndex = 2;
    }

    async redigerMoetemal() {
        if (erNil(this.valgtGruppe())) return;

        const oppdatertMal = await this.avhengigheter.visRedigerMøtemalGui(this.valgtGruppe()!, this.møtemalTrinn());
        this.oppdaterSkjemaFraMøtemal(oppdatertMal, this.valgtGruppe()!);
    }

    antallSaker() {
        return MøteOpprettInkluderteSakerKontroller.antallSakerValgt(this.skjema.value.saker!);
    }

    antallDeltakere() {
        return this.deltakere().length;
    }

    avbryt(): void {
        this.dialogRef.close(null);
    }

    async lagre() {
        await this.lagrer.utfør(async () => {
            const opprettetMøte = await this.avhengigheter.opprett(this.somSpesifikasjon());
            this.dialogRef.close({opprettetMøte, sendInnkalling: this.skjema.value.publisering!.sendInnkalling!});
        });
    }

    ngAfterViewInit(): void {
        this.ngViewInitialisert.resolve();
    }

    // MøteRedigerTidspunktKontrollerAvhengigheter impl

    validerMøtetidspunkt(møtedato: ZonedDateTimePeriodeLukket): Promise<TypetValideringsresultatModell<MøtetidspunktValideringsfeil>> {
        if (erNil(this.valgtGruppe())) return Promise.resolve(okTypetValideringsresultatModell());
        return this.avhengigheter.valider(this.somSpesifikasjon(møtedato));
    }

    opprettNyÅrsplan(årstall: number): void {
        this.avbryt();
        this.avhengigheter.visOpprettNyÅrsplanGui(årstall, this.valgtGruppe()!.id);
    }


    // MedlemInvitasjonSkjemaKomponentAvhengigheter implementasjon

    medlemsroller(): Observable<MedlemsRolleModell[]> {
        return this.medlemsroller$;
    }

    verifiserAtEpostIkkeAlleredeErRegistrert(epost: string): ValiderEpostRespons {
        return eksistererMedlemMedEpost(this.somNullsikkerGruppemedlemmer(), epost);
    }

    /** Sann dersom det ikke finnes et medlem med samme navn (casing ignorert), ignorer permanent deaktiverte medlemmer */
    verifiserAtNavnIkkeAlleredeErRegistrert(navn: string): boolean {
        return eksistererMedlemMedNavn(medlemmerIkkeAnonymisert(this.somNullsikkerGruppemedlemmer()), navn);
    }

    //private hjelpemetoder

    private somNullsikkerGruppemedlemmer() {
        return this.valgtGruppe()?.alleMedlemmer ?? [];
    }

    private async lastGrupper(valgtGruppeId: GruppeId | null) {
        this.avhengigheter.tilgjengeligeGrupper()
          .pipe(takeUntilDestroyed())
          .subscribe(tilgjengeligeGrupper => {
              this.grupper.set(tilgjengeligeGrupper);
              let forhåndsvalgtGruppe = første(this.grupper().filter(kandidat => kandidat.id === valgtGruppeId));

              //dersom kun én gruppe tilgjengelig sett denne som valgt
              const ordinæreGrupper = this.grupper().filter(gruppe => gruppe.gruppetype == Gruppetype.ordinær);
              if (erNil(forhåndsvalgtGruppe) && ordinæreGrupper.length == 1)
                  if (erNil(forhåndsvalgtGruppe)) forhåndsvalgtGruppe = første(ordinæreGrupper);

              //dersom ingen gruppe er forhåndsvalgt, gi gruppevelger fokus, ellers gi møtedato-feltet fokus
              if (erNil(forhåndsvalgtGruppe)) this.fokuserGruppeVelger();
              else this.fokuserStartdatoFelt.set(true);

              this.skjema.controls.gruppe.setValue(forhåndsvalgtGruppe);
          });
    }

    private oppdaterSkjemaNårGruppevalgEndres() {
        const gruppeEndret = toObservable(this.valgtGruppe)
          .pipe(
            filterNil(),
            //bruker kan med piltaster raskt navigere i nedtrekksmenyen - debounce for å hindre at dette fører til unødvendig mange møtemal lastinger
            debounceTime(200),
            tap(gruppe => this.oppdaterDeltakereFraGruppe(gruppe)));
        this.lastMøtemalOgOppdaterSkjema(gruppeEndret);
        this.lastAksjeeiereOgOppdaterSkjema(gruppeEndret);
    }

    private oppdaterDeltakereFraGruppe(gruppe: GruppeModell) {
        MøteRedigerDeltakereKontroller.repopulerSkjema(this.skjema.controls.deltakere, medlemmerAktive(gruppe.alleMedlemmer), [], this.destroyRef);
    }

    private lastMøtemalOgOppdaterSkjema(gruppeEndretStrøm: Observable<GruppeModell>) {
        gruppeEndretStrøm
          .pipe(
            //hver gang gruppe endres - hent møtemal - og publiser kun resultatet fra den siste leveransen til gruppeEndretStrøm
            switchMap((gruppe: EnkelGruppeModell) => this.avhengigheter.lastMalmøteModell(gruppe.id)),
            takeUntilDestroyed(this.destroyRef))
          .subscribe(malmøte =>
            this.oppdaterSkjemaFraMøtemal(malmøte, this.skjema.value.gruppe!));
    }

    /** Oppdaterer modellen med data fra angitt mal. */
    private oppdaterSkjemaFraMøtemal(mal: MalmøteModell, gruppe: GruppeModell) {
        this.malmoete.set(mal);

        let starttidspunkt = lesPlainTimeSerialisertOpt(mal.starttidspunkt);
        const maldata: SkjemaVerdier = {
            detaljer: {
                tidspunkt: {
                    startklokkeslett: starttidspunkt,
                    sluttklokkeslett: starttidspunkt?.add({minutes: mal.varighet ?? 0}) ?? null,
                },
                behandlingsmaate: mal.behandlingsMaate,
                moetested: mal.behandlingsSted
            },
            publisering: {
                erMoetePublisert: mal.erMoetePublisert,
                erProtokollPublisert: mal.erProtokollPublisert
            },
            //oppdaterDeltakereFraGruppe() vil ha sørget for å ha lagt til en rad per gruppemedlem - her fyller vi på med data fra mal
            deltakere: this.skjema.value.deltakere!.map(deltaker => {
                const deltakerFraMalmøte = mal.deltakere.find(deltakerIMal => deltakerIMal.medlem.id == deltaker.medlem!.id);
                return {valgt: erIkkeNil(deltakerFraMalmøte), skalSignere: deltakerFraMalmøte?.skalSignere ?? false}
            }),
            //saker: [] - denne strukturen blir oppdatert via @Input på MøteOpprettInkluderteSakerKontroller
            //eksterneDeltakere: [] - starter alltid som tom liste
        };

        //ikke oppdater felter som har blitt endret av bruker
        const detaljerSkjema = this.skjema.controls.detaljer.controls;
        if (detaljerSkjema.tidspunkt.controls.startklokkeslett.dirty) delete maldata.detaljer!.tidspunkt;
        if (detaljerSkjema.moetested.dirty) delete maldata.detaljer!.moetested;
        if (detaljerSkjema.behandlingsmaate.dirty) delete maldata.detaljer!.behandlingsmaate;
        this.skjema.patchValue(maldata);
    }

    private lastAksjeeiereOgOppdaterSkjema(gruppeEndretStrøm: Observable<GruppeModell>) {
        gruppeEndretStrøm
          .pipe(
            //uavhengig av om gruppen har aksjeeierbok eller ikke nullstiller vi skjema.aksjeeiere,
            //dersom gruppe har aksjeeierbok vil skjema.aksjeeiere blir populert av oppdaterSkjemaFraAksjeeiere(),
            //og dersom gruppen ikke har aksjeeierbok skal ikke skjema.aksjeeiere benyttes
            tap(() => this.skjema.controls.aksjeeiere.clear()),
            filter(gruppe => gruppe.harAksjeeierbok),
            switchMap(gruppe => combineLatest([
                this.avhengigheter.lastAksjeeiere(gruppe.aksjeeierbokId!).pipe(kunRequestRespons(), mapTilData()), //kun lever data fra request
                this.avhengigheter.lastMedlemsroller(gruppe.id)])),
            takeUntilDestroyed(this.destroyRef))
          .subscribe(([aksjeeiere, roller]) =>
            this.oppdaterSkjemaFraAksjeeiere(aksjeeiere, roller))
    }

    private oppdaterSkjemaFraAksjeeiere(aksjeeiere: AksjeeierEnkelModell[], medlemsroller: MedlemsRolleModell[]) {
        this.medlemsroller$.next(medlemsroller);
        this.standardAksjeeierRolle.set(finnAksjeeierRolle(medlemsroller))
        GeneralforsamlingRedigerRepresentasjonerKontroller.repopulerSkjema(this.skjema.controls.aksjeeiere, aksjeeiere);
    }

    /** Returnerer spesifikasjon kan benyttes ved serverkall for validering/oppdatering.
     * Siden metoden også blir kalt ifbm validering er det ikke gitt at skjemaet er gyldig. */
    //public for testbarhet
    public somSpesifikasjon(møtedato: ZonedDateTimePeriodeLukket | null = null): NyttMøteSpesifikasjon {
        const skjemaverdier = this.skjema.value;
        const dato = erIkkeNil(møtedato) ? møtedato : MøteRedigerTidspunktKontroller.somMøteDato2(skjemaverdier.detaljer!.tidspunkt!, this.avhengigheter.tidssone);
        //merk at dersom ingen av feltene i skjemaverdier.detaljer er fylt ut vil skjemaverdier.detaljer være undefined
        return {
            id: nyUuid(),
            dato: dato.somSerialiserbar(),
            behandlingsMaate: skjemaverdier.detaljer?.behandlingsmaate ?? '',
            behandlingsSted: skjemaverdier.detaljer?.moetested ?? '',
            gruppeId: skjemaverdier.gruppe!.id,
            deltakere: this.deltakere(),
            deltakereSomSkalSignereProtokoll: MøteRedigerDeltakereKontroller.somGruppemedlemIdForMedlemmerSomSkalSignere(skjemaverdier.deltakere!),
            eksterneDeltakere: MøteRedigerEksterneDeltakereKontroller.somEksternMøtedeltakerSpesifikasjon(skjemaverdier.eksterneDeltakere!),
            erMoetePublisert: skjemaverdier.publisering!.erMoetePublisert!,
            erProtokollPublisert: skjemaverdier.publisering!.erProtokollPublisert!,
            formaal: skjemaverdier.detaljer?.formaal ?? '',
            tittel: skjemaverdier.gruppe!.moetenavn,
            valgteMalsaker: MøteOpprettInkluderteSakerKontroller.somMalsakIder(skjemaverdier.saker!, this.malmoete()!.saker)
        };
    }

    /** returnerer liste med {@link MøtedeltakerSpesifikasjon} som unionen av deltakere fra
     * {@link MøteRedigerDeltakereKontroller} og {@link GeneralforsamlingRedigerRepresentasjonerKontroller}. */
    private deltakere(): MøtedeltakerSpesifikasjon[] {
        return møtedeltakerSpesifikasjonerFraAksjeeierRepresentasjonerOgMøtedeltakere(this.skjema.value.aksjeeiere!, this.skjema.value.deltakere!)
    }

    private fokuserGruppeVelger() {
        //når velgGrupperKomponent er tilgjengelig - gi fokus til denne - med forsinkelse for at ting skal ha rukket å tegne ut
        this.ngViewInitialisert.promise.then(() =>
          setTimeout(() => this.velgGrupperKomponent().giFokus(), 100))
    }

    private møtemalTrinn(): RedigerMøtemalTrinn {
        switch (this.steg().selectedIndex) {
            case 0:
                return RedigerMøtemalTrinn.moetedetaljer;
            case 1:
                return RedigerMøtemalTrinn.saker;
            case 2:
                return RedigerMøtemalTrinn.deltakere;
            case 3:
                return RedigerMøtemalTrinn.publisering;
        }
        return RedigerMøtemalTrinn.moetedetaljer;
    }
}

/** Returnerer liste med {@link MøtedeltakerSpesifikasjon} som unionen av deltakere fra skjemaene håndtert av
 * {@link MøteRedigerDeltakereKontroller} og {@link GeneralforsamlingRedigerRepresentasjonerKontroller}. */
export function møtedeltakerSpesifikasjonerFraAksjeeierRepresentasjonerOgMøtedeltakere(aksjeeierRepresentasjonerSkjema: GfRedigerRepresentasjonerSkjemaVerdier, deltakereSkjema: DeltakereSkjemaVerdier): MøtedeltakerSpesifikasjon[] {
    const aksjeeierRepresentanter = GeneralforsamlingRedigerRepresentasjonerKontroller.somMøtedeltakerSpesifikasjoner(aksjeeierRepresentasjonerSkjema);

    const ordinæreDeltakere = MøteRedigerDeltakereKontroller.somGruppemedlemIdForValgteMedlemmer(deltakereSkjema)
      //utelat fra ordinæreDeltakere deltakere som er inkludert i aksjeeierRepresentanter
      .filter(medlemId => !aksjeeierRepresentanter.some(aksjeeierRepresentant => medlemId == aksjeeierRepresentant.medlemId))
      .map(medlemId => (<MøtedeltakerSpesifikasjon>{medlemId: medlemId, medlemInvitasjon: null, representerteAksjeeiere: null}));

    return [...aksjeeierRepresentanter, ...ordinæreDeltakere];
}

export interface DialogParametre {
    valgtGruppeId: GruppeId | null;
    valgtStartdato: PlainDate | null;
}

@Injectable()
export class MøteOpprettDialogKomponentAvhengigheter {

    constructor(private møteDatatjeneste: MøteDatatjeneste,
                private møteRessurs: MøteRessursClient,
                private malmøteRessurs: MalmøteRessursClient,
                private gruppeRessurs: GruppeRessursClient,
                private gruppeDatatjeneste: GruppeDatatjeneste,
                private aksjeeierDatatjeneste: AksjeeierDatatjeneste,
                private brukerkontekst: BrukerkontekstTilbyder,
                private redigerMøtemalDialogTjeneste: RedigerMøtemalDialogTjeneste,
                private navigasjon: Navigasjon,
                private gjeldendeTidssone: GjeldendeTidssone) {
    }

    get tidssone(): Tidssoneinformasjon {
        return this.gjeldendeTidssone.brukersTidssone();
    }

    /** Liste med grupper bruker har skrivetilgang til */
    tilgjengeligeGrupper(): Observable<GruppeModell[]> {
        return this.gruppeDatatjeneste.tilgjengeligeGrupper()
          .pipe(map(grupper =>
            grupperDerBrukerHarTilgangsrolle(grupper, this.brukerkontekst.autentisertBruker(), TilgangsrolleMedlem.skrive)));
    }

    lastMalmøteModell(gruppeId: GruppeId): Promise<MalmøteModell> {
        return this.malmøteRessurs.hent(gruppeId).somPromise();
    }

    lastAksjeeiere(aksjeeierbokId: AksjeeierbokId): Observable<DataOgMeta<AksjeeierEnkelModell[]>> {
        return this.aksjeeierDatatjeneste.finnAksjeeiereTilknyttetMedMeta(aksjeeierbokId);
    }

    lastMedlemsroller(gruppeId: GruppeId): Observable<MedlemsRolleModell[]> {
        return this.gruppeRessurs.finnTilgjengeligeRoller(gruppeId).somObservable();
    }

    valider(spesifikasjon: NyttMøteSpesifikasjon): Promise<TypetValideringsresultatModell<OpprettMøteValideringsfeil>> {
        debug('valider %j', spesifikasjon)
        return this.møteRessurs.validerNyttMøte(spesifikasjon)
          .somPromiseVisStandardMeldingVedFeil(i18n('Kunne ikke validere nytt møte')) as Promise<TypetValideringsresultatModell<OpprettMøteValideringsfeil>>;
    }

    async opprett(spesifikasjon: NyttMøteSpesifikasjon): Promise<MøteModell> {
        debug('MøteOpprettDialogKomponentAvhengigheter.opprett', spesifikasjon)
        return (await this.møteDatatjeneste.opprett(spesifikasjon)).data;
    }

    async visRedigerMøtemalGui(gruppe: GruppeModell, forespurtTrinn: RedigerMøtemalTrinn): Promise<MalmøteModell> {
        const mal = await this.redigerMøtemalDialogTjeneste.visRedigerMøtemalDialogMedForespurtTrinn(kopierFraNg2TilAjs(gruppe), forespurtTrinn);
        return kopierFraAjsTilNg2(mal);
    }

    visOpprettNyÅrsplanGui(årstall: number, gruppeId: GruppeId): void {
        const planperiode = {start: new PlainDate(årstall, 1, 1), slutt: new PlainDate(årstall, 12, 31)};
        this.navigasjon.gåTilOpprettPlanMedPeriodeValgt(gruppeId, planperiode);
    }
}
